import React, { useState } from "react";
import {
  switchMfaLoginMethod,
  MFA_METHOD_EMAIL,
  MFA_METHOD_AUTHENTICATOR,
} from "../../services/mfaService";
import "./MfaMethodChoice.scss";

function MfaMethodChoice({ challenge, onSelected, onSetupRequired, onBack, loading }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const maskedEmail = challenge?.MaskedEmail ?? challenge?.maskedEmail ?? "";
  const token = challenge?.MfaSessionToken ?? challenge?.mfaSessionToken;

  const handleChoose = async (targetMethod) => {
    if (!token || submitting || loading) return;
    setSubmitting(true);
    setError("");
    try {
      const response = await switchMfaLoginMethod(token, targetMethod);
      if (response.success === 1 && response.data) {
        const merged = { ...challenge, ...response.data, RequiresMethodSelection: false };
        const needsSetup =
          merged.NeedsAuthenticatorSetup === true ||
          merged.needsAuthenticatorSetup === true;
        if (needsSetup && onSetupRequired) {
          onSetupRequired(merged);
        } else {
          onSelected(merged);
        }
      } else {
        setError(response.message || "Could not start verification.");
      }
    } catch {
      setError("Could not start verification. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const busy = submitting || loading;

  return (
    <div className="mfa-method-choice">
      <div className="mfa-verification-header">
        <button type="button" className="mfa-back-btn" onClick={onBack} disabled={busy}>
          <i className="fas fa-arrow-left" aria-hidden="true" />
        </button>
        <h2 className="mfa-verification-title">Verify your identity</h2>
      </div>

      <p className="mfa-method-choice-desc">
        How would you like to verify? You can choose a different option each time
        you sign in.
      </p>

      {error && (
        <div className="login2-alert login2-alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="mfa-method-choice-cards">
        <button
          type="button"
          className="mfa-method-choice-card"
          onClick={() => handleChoose(MFA_METHOD_EMAIL)}
          disabled={busy}
        >
          <i className="fas fa-envelope" aria-hidden="true" />
          <div>
            <strong>Email verification code</strong>
            <p>Send a 6-digit code to {maskedEmail || "your email"}</p>
          </div>
        </button>

        <button
          type="button"
          className="mfa-method-choice-card"
          onClick={() => handleChoose(MFA_METHOD_AUTHENTICATOR)}
          disabled={busy}
        >
          <i className="fas fa-mobile-alt" aria-hidden="true" />
          <div>
            <strong>Authenticator app</strong>
            <p>Google Authenticator or Microsoft Authenticator</p>
          </div>
        </button>
      </div>

      {busy && (
        <p className="mfa-method-choice-loading">
          <span className="login2-spinner" aria-hidden="true" /> Starting verification…
        </p>
      )}
    </div>
  );
}

export default MfaMethodChoice;
